import type { IUserSearchOption } from '../common/models/User'

export type EngagementCardData = {
  id: string | null
  displayName?: string
  engagementCode: string
  clientId: string
  clientName: string
  signOffDueDate?: string | null
  engagementName: string
  team: IUserSearchOption[]
  applicationsCount?: number,
  isArchived?: boolean
}

export type EngagementDetail = {
  engagementID: string;
  engagementName: string;
  clientID: string;
  clientName: string;
  isArchived?: boolean;
};

export enum TeamMemberType{
  Member = 1,
  Owner = 2,
}

export enum EvidenceStatusEnum 
{
  Uploading = 1,
  Error_Uploading = 2,
  Temp_Storage = 3,
  MalwareScan = 4,
  ScanFailed = 5,
  Yet_To_Be_Verified = 6,
  Verified = 7,
}

export type ApplicationDetail = {
  id: string 
  applicationName: string
  description: string
  statusType: number
  signOffDueDate: string
}

export type ClientCardList = Array<EngagementCardData>

export type ApplicationList = Array<ApplicationDetail>

export type ApplicationListResponse = {  
  pagedData: ApplicationList,
  totalResults: number,
  totalPages: number,
  currentPage: number,
  pageSize: number
}

export type EngagementSearchQuery = {
  query: string;
  isArchived: boolean;
}

export enum EvidenceType
{
  Developer = 1,
  Implementer = 2,
}

export enum AppropriatenessFilterType
{
  All = "0",
  Department = "1",
  AppropriatenessYes = "2",
  AppropriatenessNo = "3",
  AppropriatenessNeedMoreInfo = "4",
}

export enum JobRecordStatusType
{
  NotStarted = 0,
  InProgress = 1,
  TextExtracted = 2,
  TextExtractionFailed = 3,
  TextEvaluated = 4,
  TextEvaluationFailed = 5,
  Completed = 6,
  Failed = 7,
  /** Submitted to the async AI/LLM evaluation step; awaiting its result callback (job-results-notify/job-check-in). Not "running" in the AZF sense. */
  Submitted = 8
}